import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const PopularTranslations = wrapTranslationsSchema({
	name: 'PopularTranslations',
	title: 'Popular Translations',
	sanityId: 'popular',
	fields: {
		marketplace: 'Marketplace',
		title: 'Popular items',
		storeTitle: 'Popular in {store}',
	},
});
